import { useTranslation } from "react-i18next";

import { router } from "../../app/services/router";
import { A } from "../shared/A";
import { Anchor } from "../shared/Anchor";

export const ForgotPasswordLink = () => {
  const { t } = useTranslation();
  const { text } = t("features.core.ForgotPasswordLink") as unknown as {
    text: string;
  };

  return (
    <Anchor
      as={A}
      href={router.getTo("authenticationForgotPassword")}
      variant="forward"
    >
      {text}
    </Anchor>
  );
};
